import Vue from "vue";
import teReo from "../mixins/teReo";
import isset from "isset";

const SORT_OPTIONS = {
  // Asc
  Title: (field, a, b) => {
    if (a[field] === b[field]) return 0;
    return a[field] > b[field] ? 1 : -1;
  },
  // Desc
  Popularity: (field, a, b) => {
    if (a[field] === b[field]) return 0;
    return a[field] < b[field] ? 1 : -1;
  },
  // Asc
  Taxonomy: (field, a, b) => {
    if (a[field] === b[field]) return 0;
    return a[field] > b[field] ? 1 : -1;
  }
};

class identifierFilter {
  constructor({ Title, TitleTeReo, Slug, Thumbnail }, Identifier) {
    this.Title = Title;
    this.TitleTeReo = TitleTeReo;
    this.Slug = Slug;
    this.Selected = false;
    this.Thumbnail = Thumbnail;
    this.Identifier = Identifier;
  }

  get URL() {
    return `${this.Identifier}_${this.Slug}`;
  }
}

class identifierType {
  constructor({ Title, TitleTeReo, Slug, Operator, Multiple, Filters }) {
    this.Title = Title;
    this.TitleTeReo = TitleTeReo;
    this.Slug = Slug;
    this.Operator = Operator;
    this.Multiple = Multiple;
    this.Filters = Filters.map(
      filter => new identifierFilter(filter, this.Slug)
    );
  }

  get activeFilters() {
    return this.Filters.filter(f => f.Selected);
  }

  setTitleTeReo(title) {
    this.TitleTeReo = title;
    return this;
  }

  setThumbnail(path) {
    this.Thumbnail = path;
    return this;
  }

  // Get a list of identifier filters from the given string
  // Only returning the current identifier type
  // ie colour_blue,colour_red,size_big will return ['blue,red'] if the current type is colour
  filtersFromString(filters) {
    return filters
      .split(",")
      .map(filter => {
        if (!isset(filter)) {
          return null;
        }
        const parts = filter.trim().split("_");
        if (parts[0] === this.Slug) {
          return this.Filters.find(f => f.Slug === parts[1]);
        } else {
          return null;
        }
      })
      .filter(f => f);
  }

  setFilter(filters) {
    this.filtersFromString(filters).forEach(filter => {
      filter.Selected = true;
    });
    return this;
  }

  factCheck(fact) {
    // No filters in place for this identifier so just pass it.
    if (!this.activeFilters.length) {
      return true;
    }

    if (this.Operator === "or") {
      return this.activeFilters.some(item => {
        return fact.Filters.indexOf(item.URL) !== -1;
      });
    } else {
      return this.activeFilters.every(item => {
        return fact.Filters.indexOf(item.URL) !== -1;
      });
    }
  }
}

const identifiertool = new Vue({
  el: "#identification-tool",
  mixins: [teReo],
  data: {
    activeFacts: [],
    Facts: [],
    Types: [],
    sort: "Popularity"
  },
  mounted() {
    const identifierData = window.MWLRIdentifierData || {};
    this.Facts = identifierData.Facts || [];
    this.Types = identifierData.Types || [];

    // Classify idenfifiers and filters then apply selected state to active filters
    const url = new URL(window.location.href);
    const filters = url.searchParams.get("filters")
      ? url.searchParams.get("filters")
      : "";
    this.Types = this.Types.map(type => {
      return new identifierType(type).setFilter(filters);
    }).sort();

    const sort = url.searchParams.get("sort");
    if (SORT_OPTIONS[sort] && sort !== "Popularity") {
      this.sort = sort;
    }

    this.filterResults();
  },
  methods: {
    toggleFilter(type, filter, event) {
      if (!type.Multiple) {
        type.Filters.filter(f => f.Slug !== filter.Slug).forEach(f => {
          f.Selected = false;
        });
      }

      if (!filter.Selected) {
        filter.Selected = true;
      } else {
        filter.Selected = false;
      }

      this.filterResults();
      this.recordState();
    },
    filterResults() {
      this.activeFacts = this.Facts.filter(fact => {
        return this.Types.every(filter => filter.factCheck(fact));
      });
      this.sortResults();
    },
    sortResults() {
      const field =
        this.sort === "Title" && this.teReo ? "TitleTeReo" : this.sort;
      this.activeFacts = this.activeFacts.sort(
        SORT_OPTIONS[this.sort].bind(this, field)
      );
      this.recordState();
    },
    recordState() {
      // Capture the current state into the URL and push this new state into history
      const searchParams = new URLSearchParams();

      const activeFilters = this.Types.map(identifier => {
        return identifier.activeFilters.map(f => f.URL);
      }).filter(t => t.length);

      if (activeFilters.length) {
        searchParams.set("filters", activeFilters);
      }
      if (this.teReo) {
        searchParams.set("lang", "mi");
      }

      if (this.sort && this.sort !== "Popularity") {
        searchParams.set("sort", this.sort);
      }

      const url = new URL(window.location.href);
      searchParams.sort();
      url.search = searchParams.toString();

      window.history.replaceState(
        {
          Filters: activeFilters
        },
        null,
        url.href
      );
    }
  }
});
